import { BaseValidator } from '../core/BaseValidator.js';
import { ValidationResult } from '../core/ValidationResult.js';

/**
 * Philippine Unified Multi-Purpose ID validator following Single Responsibility Principle
 */
export class PhValidator extends BaseValidator {
  constructor() {
    super({
      name: 'Philippine UMID',
      pattern: /^\d{4}-?\d{7}-?\d$/,
      length: 12
    });
  }

  validateFormat(id) {
    const cleanId = id.replace(/-/g, '');
    
    // Check length
    const lengthValidation = this.validateLength(cleanId, this.config.length);
    if (!lengthValidation.isValid) {
      return lengthValidation;
    }

    // Check pattern
    return this.validateRegex(
      id,
      this.config.pattern,
      'Philippine UMID format must be XXXX-XXXXXXX-X'
    );
  }

  validateChecksum(id) {
    // UMID uses Luhn algorithm
    const cleanId = id.replace(/-/g, '');
    let sum = 0;
    let alternate = false;

    for (let i = cleanId.length - 2; i >= 0; i--) {
      let n = parseInt(cleanId[i]);
      
      if (alternate) {
        n *= 2;
        if (n > 9) {
          n = (n % 10) + 1;
        }
      }
      
      sum += n;
      alternate = !alternate;
    }

    const expectedChecksum = (10 - (sum % 10)) % 10;
    const actualChecksum = parseInt(cleanId[cleanId.length - 1]);

    if (expectedChecksum !== actualChecksum) {
      return ValidationResult.invalid(`Invalid UMID checksum. Expected: ${expectedChecksum}, Got: ${actualChecksum}`);
    }

    return ValidationResult.valid('Valid Philippine UMID');
  }
}